// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1Uo4f","content":"LoadingAlert_content__-8uZs"};